import { useRouter } from "next/router";
import Shimmer from "../Shimmer";
import ShimmerItem from "../Shimmer/ShimmerItem";
import { useMemo } from "react";

const InlineFormShimmer = () => {
  const router = useRouter();

  const isBlogs = useMemo(() => {
    return (
      router.asPath.includes("/blogs/") || router.asPath.includes("/news/")
    );
  }, [router.asPath]);

  return (
    <Shimmer className="p-4">
      <ShimmerItem height="24px" width="100%" key={`shimmer-item-1`} />
      <ShimmerItem
        height="16px"
        width="50%"
        align="center"
        key={`shimmer-item-2`}
      />
      <ShimmerItem
        height="16px"
        width="80%"
        align="center"
        key={`shimmer-item-3`}
      />
      <ShimmerItem
        className="mt-4"
        height="12px"
        width="25%"
        key={`shimmer-item-4`}
      />
      <ShimmerItem height="20px" width="100%" key={`shimmer-item-5`} />
      <ShimmerItem
        className="mt-4"
        height="12px"
        width="25%"
        key={`shimmer-item-6`}
      />
      <ShimmerItem height="20px" width="100%" key={`shimmer-item-7`} />
      <ShimmerItem
        className="mt-4"
        height="12px"
        width="25%"
        key={`shimmer-item-8`}
      />
      <ShimmerItem height="20px" width="100%" key={`shimmer-item-9`} />
      <ShimmerItem
        className="mt-4"
        height="12px"
        width="25%"
        key={`shimmer-item-10`}
      />
      <ShimmerItem height="20px" width="100%" key={`shimmer-item-11`} />
      {isBlogs && (
        <>
          {Array.from({ length: 6 }).map((_, index) => (
            <>
              <ShimmerItem
                className="mt-4"
                height="12px"
                width="25%"
                key={`shimmer-item-full-${index}`}
              />
              <ShimmerItem
                height="20px"
                width="100%"
                key={`shimmer-item-half-${index}`}
              />
            </>
          ))}
        </>
      )}
      <ShimmerItem
        align="center"
        className="mt-4"
        height="36px"
        width="150px"
        key={`shimmer-item-12`}
      />
    </Shimmer>
  );
};

export default InlineFormShimmer;